import {
    apiClient as api
} from './APIService'

/**
 * @param {array} data.line_items
 * @param {string} data.line_items[].price
 * @param {number} data.line_items[].quantity
 * 
 * @param {string} customer_email
 * @returns {Promise} checkoutSession
 */
export const createCheckoutSession = (data) => {
    return api.post('stripe/checkout/create', data)
}

export const getProductById = (id, attach) => {
    return api.get(`stripe/product/${id}`, {
        params: {
            attach
        }
    })
}

export const getProducts = (query) => {
    return api.get('stripe/products', {
        params: query
    })
}

export const getCheckoutSession = (checkoutSessionID) => {
    return api.get('stripe/checkout/' + checkoutSessionID)
}

export const getPricesByLookupKeys = (prices) => {
    return api.get('stripe/prices/lookup-keys', {
        params: prices
    })

}